import React from "react";
import { Typography, Link, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Sheet, SheetContent, IntroText } from "../../components";

const Show404 = () => {
  const { t } = useTranslation();

  return (
    <Box data-cy="page-404">
      <Sheet>
        <SheetContent>
          <IntroText>{t("common.page_not_found")}</IntroText>
          <Typography align="center" paragraph>
            <Link href="/">{t("common.go_home")}</Link>
          </Typography>
        </SheetContent>
      </Sheet>
    </Box>
  );
};

export { Show404 };
